<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1>DYP 2026</h1>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="members">
        <v-sheet elevation="1" class="pa-4" rounded>
          
          <!--<v-col cols="12">
            <v-simple-table :headers="headers" :items="employees">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th v-for="header in headers" :key="header.text">
                      {{header.text}}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item, index in challengeSignups"
                    :key="index"
                  >
                    <td>{{ item.customerId }}</td>
                    <td>{{ item.customerName }}</td>
                    <td>{{ item.customerEmail }}</td>
                    <td>{{ item.referral }}</td>
                    <td><a :href="`https://rayoga.marianatek.com/admin/user/profile/${item.customerId}/payment-methods`">Mariana Profile</a></td>
                    <td>{{ item.createdAt }}</td>
                    <td>{{ item.hasPaid }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>-->

          <v-col>
            <v-data-table
              v-if="members"
              :options="{ itemsPerPage: -1 }"
              sort-by="createdAt"
              :headers="headers"
              :items="members">
              <template v-slot:item.lastName="{ item }">
                <span v-if="item">{{ item.firstName }} {{ item.lastName }}</span>
              </template>
              <tempalte v-slot:item.pledgeClasses="{ item }">
                <span>{{ item.pledgedClasses }}</span>
              </tempalte>
              <template v-slot:item.totalClasses="{ item }">
                <span>{{ item.totalClasses }}</span>
              </template>
              <template v-slot:item.charityId="{ item }">
                <span v-if="item.charityId === 4">Yoga Gives Back</span>
                <span v-if="item.charityId === 5">BBYCF</span>
                <span v-if="item.charityId === 6">ADAPTFIT</span>
              </template>
              <template v-slot:item.marianaTekId="{ item }">
                <span>{{ item.marianaTekId }}</span>
              </template>
              <template v-slot:item.referral="{ item }">
                <span>{{ item.referral }}</span>
              </template>
              <template v-slot:item.hasPaid="{ item }">
                <v-icon v-if="item.hasPaid">mdi-check-bold</v-icon>
              </template>
              <template v-slot:item.email="{ item }">
                <span>{{ item.email }}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
// import find from 'lodash/find'

export default {
  name: 'ChallengesPage',

  data() {
    return {
      /*headers: [
        {
          text: 'Mariana ID',
          value: 'customerId'
        },
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Referral',
          value: 'referral'
        },
        {
          text: 'Mariana Profile',
          value: '',
        },
        {
          text: 'Signup Date',
          value: 'createdAt'
        }
      ],*/
      headers: [
        { text: 'Name', value: 'lastName' },
        { text: 'Pledged Classes', value: 'pledgeClasses' },
        { text: 'Classes Taken', value: 'totalClasses' },
        { text: 'Charity', value: 'charityId' },
        { text: 'Mariana Account', value: 'marianaTekId' },
        { text: 'Referral', value: 'referral' },
        { text: 'Paid', value: 'hasPaid' },
        { text: 'Email', value: 'email' },
      ],
    }
  },

  computed: {
    ...mapGetters({
      challengeSignups: 'signup/list',
    }),
    challengesLoading() {
      return this.$store.state['signup'].isFindPending
    },
    membersLoading() {
      return this.$store.state['member'].isFindLoading
    },

    isMemberRemovePending() {
      return this.$store.state['member'].isRemovePending
    },
    members() {
      return this.$store.getters['member/list'].filter(m => m.dypId === 5)
    }
  },

  methods: {
    async getDypMembers() {
      this.$store.dispatch('member/find', {
        query: {
          dypId: 5,
          //hasPaid: true,
          $limit: 1000,
        }
      })
    },
    async getChallengeMemebers(challengeId) {
      this.$store.dispatch('signup/find', {
        query: {
          challengeId,
          $limit: 1000,
        }
      })
    },
    formatDate(date) {
      return DateTime.fromISO(date).plus({ 'days': 1 }).toISODate()
    }
  },

  async beforeMount() {
    //await this.getChallengeMemebers(4)
    await this.getDypMembers()
  }
}
</script>

<style lang="scss">

</style>